import { render, staticRenderFns } from "./InvitePeople.vue?vue&type=template&id=0aab6854&scoped=true"
import script from "./InvitePeople.vue?vue&type=script&lang=js"
export * from "./InvitePeople.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aab6854",
  null
  
)

export default component.exports